"use client";

type TrackingPayload = Record<string, unknown>;

type UtmParams = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  ad_id?: string;
  adset_id?: string;
  channel?: string;
};

const isBrowser = typeof window !== "undefined";

const getWindow = (): (Window & typeof globalThis & { fbq?: (...args: any[]) => void; dataLayer?: any[]; gtag?: (...args: any[]) => void }) | null => {
  if (!isBrowser) return null;
  return window as any;
};

export const readUtmParams = (): UtmParams => {
  if (!isBrowser) return {};
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source") || undefined,
    utm_medium: params.get("utm_medium") || undefined,
    utm_campaign: params.get("utm_campaign") || undefined,
    utm_content: params.get("utm_content") || undefined,
    utm_term: params.get("utm_term") || undefined,
    ad_id: params.get("ad_id") || undefined,
    adset_id: params.get("adset_id") || undefined,
    channel: params.get("channel") || undefined,
  };
};

export const readPrefillParams = () => {
  if (!isBrowser) return {};
  const params = new URLSearchParams(window.location.search);
  return {
    name: params.get("name") || params.get("full_name") || undefined,
    email: params.get("email") || undefined,
    resume_text: params.get("resume_text") || params.get("resume") || undefined,
    worry: params.get("worry") || undefined,
  };
};

export const trackEvent = (eventName: string, payload: TrackingPayload = {}) => {
  const win = getWindow();
  if (!win) return;

  const enrichedPayload = {
    event: eventName,
    event_category: "diagnosis_form",
    ...payload,
  };

  try {
    win.dataLayer = win.dataLayer || [];
    win.dataLayer.push(enrichedPayload);
  } catch (error) {
    // noop
  }

  if (typeof win.gtag === "function") {
    win.gtag("event", eventName, enrichedPayload);
  }

  if (typeof win.fbq === "function") {
    win.fbq("trackCustom", eventName, payload);
  }
};
